export default {
  data() {
    return {
      clickedButtonName: '',
    };
  },
  methods: {
    setClickedButtonName(name) {
      this.clickedButtonName = name;
    },
    emitStatsShowModalEvent() {
      this.$stats.showModal({
        params: {
          modalName: this.modalName,
          url: this.$router.currentRoute.fullPath,
        },
      });
    },
    emitStatsDestroyModalEvent() {
      const params = {
        clickedButtonName: this.clickedButtonName,
        modalName: this.modalName,
        url: this.$router.currentRoute.fullPath,
      };

      if (this.clickedButtonName) {
        return this.$stats.clickModal({ params });
      }

      this.$stats.closeModal({ params });
    },
  },
};
